<template>
  <div>
    <header-top :headerText="headerText" showBack></header-top>
    <div class="wrap">
      <div class="content">
        <img class="idCard" src="@/assets/image/id-card.png" alt="身份证" />
        <div class="info-box" style="border-right: 1px solid #e5e5e5;">
          <div class="item title">认证信息</div>
          <div class="item flex">
            <div class="key">个人名称</div>
            <div>**洁</div>
          </div>
          <div class="item flex">
            <div class="key">身份证号</div>
            <div>4****************0</div>
          </div>
          <div class="item flex">
            <div class="key">认证类型</div>
            <div>个人认证</div>
            <div class="edit">修改实名认证</div>
          </div>
        </div>
        <div class="info-box" style="padding-right: 0;">
          <div class="item title">认证方式</div>
          <div class="item flex">
            <div class="key">认证地区</div>
            <div>中国大陆</div>
          </div>
          <div class="item flex">
            <div class="key">认证方式</div>
            <div>微信认证</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
export default {
  components: {
    headerTop,
  },
  data() {
    return {
      headerText: "认证信息",
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/mixin.scss";
.content {
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
  @include flex(row, flex-star);
  align-items: flex-start;
  padding: 40px 44px;
  background-color: #fff;
  .idCard {
    width: 260px;
    height: 158px;
  }
  .info-box {
    min-width: 230px;
    padding: 20px 5.7% 0 7%;
    .title {
      text-align: left;
      font-size: 14px;
      font-weight: bold;
      color: #000;
    }
    .item {
      padding-bottom: 20px;
      color: #000;
      .key {
        color: #888;
        padding-right: 44px;
      }
      .edit {
        padding-left: 15px;
        color: $--color-primary;
        cursor: pointer;
      }
    }
    .item:last-child {
      padding-bottom: 0;
    }
  }
}

.wrap {
  padding: 20px;
}
</style>
